import "./App.css";
import "./styles/Legacy.scss";
import { useEffect } from 'react';
import { initAnalytics } from "./utils/analytics";
import AppRoutes from "./routes/AppRoutes";
import { BrowserRouter } from "react-router-dom";

function App() {

  useEffect(() => {
    initAnalytics();
  }, []);

  return <BrowserRouter>
    <div className="h-dvh overflow-scroll">
      <AppRoutes />
    </div>
  </BrowserRouter>
}

export default App;
